export function Logo({ variant = "dark", className = "", size = 44, testId = "brand-logo" }) {
  const textColor = variant === "light" ? "#ffffff" : "#3E5641";
  const dataProps = testId ? { "data-testid": testId } : {};
  return (
    <a
      href="/"
      className={`inline-flex items-center gap-2.5 ${className}`}
      aria-label="La Dupla Automotriz — Inicio"
      {...dataProps}
    >
      <img
        src="/ladupla-logo.png"
        alt="La Dupla Automotriz"
        width={size}
        height={size}
        className="block object-contain"
        style={{ width: size, height: size }}
      />
      <span
        className="font-serif text-xl font-semibold tracking-tight leading-none"
        style={{ color: textColor }}
      >
        Dupla Automotriz
      </span>
    </a>
  );
}
